import React from "react";
import { Table } from "@coverme/table";

const columns = [
    {
        Header: () => <span>Assistance Category</span>,
        accessor: "assistanceCategory",
        width: 300,
    },
    {
        Header: () => <span>Reason for Ineligibility </span>,
        accessor: "reasonForIneligibility",
        width: 600,
    },
];

export const IneligiblePrograms = ({ programs, patientName = "the patient", gender = "Female" }) => {
    return (
        <div className="ineligible-programs">
            <h3 className="ineligible-programs-header">Other Programs We Considered</h3>
            <p>
                We considered the patient for the following programs as well. {gender === "Male" ? "He" : "She"} was
                found ineligible for them for the reasons documented below.
            </p>
            <Table data={programs} columns={columns} pageSize={10} />
        </div>
    );
};
